<template>
    <div class="bg-white text-gray-900 text-base p-8 print:p-0 print:text-black min-h-screen font-sans">
        <!-- Header -->
        <div class="max-w-5xl mx-auto">
            <div class="flex items-center justify-between mb-6 border-b pb-4">
                <!-- Company Logo -->
                <div class="w-40">
                    <img
                        :src="bill.user.kyc.logo"
                        alt="Company Logo"
                        class="object-contain w-full h-auto"
                    />
                </div>

                <!-- Invoice Details -->
                <div class="text-right">
                    <h2 class="text-3xl font-bold uppercase tracking-wide">INVOICE</h2>
                    <p class="mt-1 text-sm font-semibold">
                        Invoice No: <span class="font-bold">#{{ bill.bill_number }}</span>
                    </p>
                    <p class="text-sm font-semibold">Date: {{ bill.created_at | readableDate }}</p>
                    <p class="text-sm font-semibold">Payment Method: {{ bill.payment_method }}</p>
                </div>
            </div>

            <!-- Parties -->
            <div class="flex flex-row justify-between gap-6 mt-8 border border-gray-300 p-6 rounded grid-cols-2">
                <div class="flex-1">
                    <h2 class="font-semibold text-lg underline mb-2">Billed To:</h2>
                    <p class="text-lg">{{ bill.user.name }}</p>
                    <p class="text-base">{{ bill.user.kyc.business_address }}</p>
                </div>
                <div class="flex-1">
                    <h2 class="font-semibold text-lg underline mb-2">From:</h2>
                    <p class="text-lg">{{ bill.wholesaler.name }}</p>
                    <p class="text-base">{{ bill.wholesaler.kyc.business_address }}</p>
                </div>
                <div class="w-24 h-24">
                    <img
                        v-if="bill.qr_code"
                        :src="bill.qr_code"
                        alt="QR Code"
                        class="w-full h-full object-contain"
                    />
                </div>
            </div>

            <!-- Products Table -->
            <table class="w-full mt-8 border border-collapse text-lg">
                <thead class="bg-gray-100">
                    <tr>
                        <th class="border px-4 py-2 text-left">#</th>
                        <th class="border px-4 py-2 text-left">Item</th>
                        <th class="border px-4 py-2 text-right">Qty</th>
                        <th class="border px-4 py-2 text-right">Price</th>
                        <th class="border px-4 py-2 text-right">Vat</th>
                        <th class="border px-4 py-2 text-right">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(transaction, index) in bill.transactions"
                        :key="transaction.id"
                        class="border-t"
                    >
                        <td class="border px-4 py-2">{{ index + 1 }}</td>
                        <td class="border px-4 py-2">{{ transaction.product.name }}</td>
                        <td class="border px-4 py-2 text-right">{{ transaction.qty }}</td>
                        <td class="border px-4 py-2 text-right">
                            {{ config(common.currency) }} {{ parseFloat(transaction.product.price).toFixed(2) }}
                        </td>
                        <td class="border px-4 py-2 text-right">
                            {{ config(common.currency) }} {{ parseFloat(transaction.vat).toFixed(2) }}
                        </td>
                        <td class="border px-4 py-2 text-right">
                            {{ config(common.currency) }} {{ parseFloat(transaction.grand_total).toFixed(2) }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Totals -->
            <div class="flex justify-end mt-6">
                <div class="w-full sm:w-1/2 text-lg space-y-2">
                    <div class="flex justify-between">
                        <span>Subtotal:</span>
                        <span>{{ config(common.currency) }} {{ parseFloat(bill.total_amount).toFixed(2) }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span>Paid:</span>
                        <span>{{ config(common.currency) }} {{ parseFloat(bill.amount_paid).toFixed(2) }}</span>
                    </div>
                    <div
                        class="flex justify-between"
                        v-if="bill.amount_remaining"
                    >
                        <span>Remaining:</span>
                        <span>{{ config(common.currency) }} {{ parseFloat(bill.amount_remaining).toFixed(2) }}</span>
                    </div>
                </div>
            </div>

            <!-- Notes -->
            <div
                v-if="bill.notes"
                class="mt-6"
            >
                <h3 class="font-semibold text-lg">Notes:</h3>
                <div class="bg-gray-50 border p-4 rounded text-base mt-2">{{ bill.notes }}</div>
            </div>

            <!-- Stamp -->
            <!-- <div class="flex justify-end mt-16">
                <div class="w-32 h-32">
                    <img src="/images/stamp.png" alt="Company Stamp" class="w-full h-full object-contain" />
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    // import print from 'vue-print-nb';
    import common from '../../common';

    export default {
        name: 'InvoiceTemplate',

        props: {
            bill: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                common,
                printObj: {
                    id: '#print-invoice',
                    popTitle: 'B2B Shopping',
                    // extraCss: 'https://www.google.com,https://www.google.com',
                    extraHead: '<link href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css" rel="stylesheet">',
                },
            };
        },
    };
</script>

<style></style>
